<template>
  <div ref="gatt_table"
    class="gatt-table">
    <div class="gatt-thead" :style="{width: widthTable + 'px'}">
      <div class="gatt-th"
        :key="key"
        v-for="(th,key) in headData"
        v-show="!th.hideHead"
      >
        <div class="cell"
          :style="{width:th.width ? th.width+'px' : '80px'}"
        >
          {{th.value}}
        </div>
      </div>
    </div>
    <div class="gatt-tbody"
      ref="gattTbody"
      :style="{width: widthTable + 'px'}"
      @scroll.stop="tableScroll()">
      <gatttable-tr
        @handleClick="handleClick"
        @change="change"
        :allData="data"
        :data="data"
        ref="gatttableTr"
        :headData="headData"
      >
      </gatttable-tr>
    </div>
  </div>
</template>

<script>
import Bus from '@/components/common/bus'
import GatttableTr from './components/GatttableTr.vue'
export default {
  name: '',
  props: {
    headData: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Array,
      default: () => []
    },
    uuId: String
  },
  computed: {
    widthTable () {
      let sum = 0
      let w = 0
      for (const key in this.headData) {
        if (!this.headData[key].hideHead) {
          if (this.headData[key].width) {
            w = ~~this.headData[key].width
          } else {
            w = 80
          }
        } else {
          w = 0
        }
        sum += w
      }
      return sum
    }
  },
  components: {
    GatttableTr
  },
  data () {
    return {}
  },
  mounted () {
    this.getScrollTop()
  },
  methods: {
    change (tdData) {
      this.$emit('change', tdData)
    },
    handleClick (data) {
      this.$emit('handleClick', data)
    },
    // eslint-disable-next-line camelcase
    change_calendar (data) {
      this.$emit('change-calendar', data)
    },
    tableScroll () {
      this.$nextTick(() => {
        const scrolled = this.$refs.gattTbody.scrollTop
        // eslint-disable-next-line no-undef
        Bus.$emit('gattViewTableScroll', { scrolled, uuid: this.uuId })
      })
    },
    getScrollTop () {
      Bus.$on('gattViewScroll', d => {
        this.$nextTick(() => {
          if (this.uuId === d.uuid) {
            this.$refs.gattTbody.scrollTop = d.scrolled
          }
        })
      })
    }
  }
}
</script>
<style>
.gatt-table {
  font-size: 14px;
  display: table;
  table-layout: fixed;
  word-break: break-all;
  position: relative;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  height: 100%;
}
.gatt-table::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.gatt-table::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.gatt-table::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
  background-color: #ccc;
}
.gatt-table .gatt-thead {
  line-height: 44px;
  height: 44px;
  background-color: #f3f3f3;
}
.gatt-table .gatt-thead .gatt-th {
  display: table-cell;
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: left;
  color: #909399;
  font-weight: bold;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  line-height: 43px;
  background-color: #f3f3f3;
}
.gatt-table .gatt-thead .gatt-th .cell {
  position: relative;
  word-wrap: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;
  min-height: 16px;
}
.gatt-table .gatt-tbody {
  position: relative;
  height: calc(100% - 44px);
  overflow-x: hidden;
  overflow-y: auto;
}
.gatt-table .gatt-tbody::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.gatt-table .gatt-tbody::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.gatt-table .gatt-tbody::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
  background-color: #ccc;
}
</style>
